import styled from "styled-components";

const ContentStylesContainer = styled.section`
    margin: 30px 0 30px;

    .page-split-view {
        .links-sec {
            width: 100%;
            border-bottom: 2px solid #ddd;
            padding-bottom: 15px;
            margin-bottom: 25px;
            @media (min-width: 992px) {
                width: 250px;
                border-right: 1px solid #ddd;
                border-bottom: none;
            }
            > .inner {
                @media (min-width: 992px) {
                    position: sticky;
                    top: 10px;
                }
            }
            .link {
                color: #333;
                &:hover {
                    color: #000;
                }
            }
        }
        .text-sec {
            line-height: 30px;
            @media (max-width: 992px) {
                width: 100%;
            }
        }
    }

    .accordian-view {
        .accordian-item {
            .acc-header {
                border: 1px solid #ddd;
                padding: 20px;
                font-size: 18px;
                cursor: pointer;
                &:focus {
                    border-color: #333;
                }
                &.active {
                    border-color: #333;
                }
            }

            .acc-content {
                background: #f2f2f2;
                padding: 20px;
                .item {
                    font-size: 18px;
                }
            }
        }
    }
`;

const BreadcrumbsHeaderContainer = styled.div`
    padding-bottom: 20px;
    .heading {
        font-size: 25px;
        font-weight: 800;
        margin-bottom: 5px;
        text-transform: uppercase;
    }
    .link {
        color: #757575;
        transition: 0.2s;
        &:last-child {
            // pointer-events: none;
            font-weight: 600;
        }

        &:hover {
            color: #757575;
        }
    }

    .ec-breadcrumbs {
        color: #757575;
        font-size: 16px;
    }
`;

export { ContentStylesContainer, BreadcrumbsHeaderContainer };
